import { SSIPosition } from 'const';

export function isVerticalSSIPosition(position: SSIPosition): boolean {
  return position === SSIPosition.VERTICAL;
}

export function isHorizontalSSIPosition(position: SSIPosition): boolean {
  return position === SSIPosition.HORIZONTAL;
}
